import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../style.module.scss';
import cN from 'classnames';
import GroupTripInfoFlight from '@components/DetailPage/GroupTripInfoFlight';
import { AirPlane } from '@components/Common/Icons';

const Flight = () => {
    const Group = useSelector((store: RootState) => store.groupReducer);
    const [openLightbox, setOpenLightbox] = useState<boolean>(false);

    return Group.GoTransferCount > 0 || Group.BackTransferCount > 0 ? (
        <div className={cN(styles['group-trip-info'], styles.flight, 'group_trip_info', 'flight')}>
            <div className={cN(styles.title)}>參考航班</div>
            <div className={styles.content}>
                <div className={styles.infos}>
                    <div className={styles['sub-title']}>去程</div>
                    <ul>
                        <li className={styles.dep}>
                            {Group.GoDepartureTime}&nbsp;{Group.GoDepartureAirport}
                        </li>
                        <li className={styles.decoration} />
                        <li className={styles.arr}>
                            {Group.GoArriveTime}&nbsp;{Group.GoArriveAirport}
                        </li>
                    </ul>
                    <div className={styles['airline']}>{Group.GoAirline}</div>
                </div>
                <div className={styles.infos}>
                    <div className={styles['sub-title']}>回程</div>
                    <ul>
                        <li className={styles.dep}>
                            {Group.BackDepartureTime}&nbsp;
                            {Group.BackDepartureAirport}
                        </li>
                        <li className={styles.decoration} />
                        <li className={styles.arr}>
                            {Group.BackArriveTime}&nbsp;{Group.BackArriveAirport}
                        </li>
                    </ul>
                    <div className={styles['airline']}>{Group.BackAirline}</div>
                </div>
                <div className={styles.tips}>
                    航班時間僅為參考，最終確定之使用航班，以說明會資料為準！
                </div>
            </div>
            <span className={styles.btns} onClick={() => setOpenLightbox(!openLightbox)}>
                <AirPlane fill="#222" />
                航班詳情
            </span>
            <GroupTripInfoFlight
                open={openLightbox}
                ToggleLightBox={() => setOpenLightbox(false)}
                storyData={{ url: '/mockData/GroupAllCalendarMoreForeign.json' }}
            />
        </div>
    ) : null;
};

export default Flight;
